import styled from 'styled-components';
import React, {useEffect, useRef, useState} from "react";
import {useHistory} from "react-router-dom";
import {ChevronDown} from "lucide-react";
import {themecolors} from "../utils/themecolors";

const BottomTabBar = styled.div`
  position: relative;
  bottom: 0;
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_6 : themecolors.lighter_border};
  overflow: hidden;
`;

const TabsContainer = styled.div`
  display: flex;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
/*  justify-content: space-around;*/
  &::-webkit-scrollbar {
    display: none;
  }
  width: 100%;
  position: relative;
`;

const Tab = styled.div`
  flex: 0 0 auto;
  width: auto;
  padding: 12px 16px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: ${({ activeTab, tab, theme }) =>
          activeTab === tab ? (theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text) : theme.color.name === 'dark' ? themecolors.dark_low_impact_text : themecolors.light_low_impact_text};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: color 0.3s ease;
  position: relative;

  svg {
    margin-left: 4px;
    width: 16px;
    height: 16px;
  }

  &:active {
    opacity: 0.6;
  }
`;

const Underline = styled.div`
  position: absolute;
  bottom: 0;
  height: 3px;
  border-radius: 0px;
  background-color: ${({ theme }) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
  transition: all 0.3s ease-in-out;
  // Adjust width to be 8px shorter (4px on each side)
  width: ${({ tabWidths, activeTabIndex }) => (tabWidths[activeTabIndex] || 0) - 24}px;

  // Centering logic: offset by half the difference between the full tab width and underline width
  transform: translateX(
          ${({ tabWidths, tabOffsets, activeTabIndex }) =>
                  (tabOffsets[activeTabIndex] || 0) + (tabWidths[activeTabIndex] || 0) / 2 - ((tabWidths[activeTabIndex] || 0) - 24) / 2}px
  );
`;

const PostSymbol = styled.div`
margin-left: 0px;
display: flex;
align-items: center;
margin-right: -4px;
  `
;

const CommunityFeedMenu = ({ activeTab, setActiveTab, tabs, sort, setSortOpen, community }) => {
    const [tabWidths, setTabWidths] = useState([]);
    const [tabOffsets, setTabOffsets] = useState([]);
    const tabsRef = useRef([]);
    const containerRef = useRef();
    const observer = useRef(null);

    const formattedSort = sort ? `${sort.charAt(0).toUpperCase() + sort.slice(1)} Posts` : "Hot Posts";
    const defaultTab = tabs.includes(activeTab) ? activeTab : "Hot Posts";

    const history = useHistory();

    const handleTabClick = (tab) => {
        if (tab.includes("Posts") && activeTab.includes("Posts")) {
            setSortOpen(true);
            return;
        }
        if (!tab.includes('Posts')) {
            history.push(`/c/${community}/${tab.toLowerCase()}`);
        } else {
            history.push(`/c/${community}`);
        }
        setActiveTab(tab);
    };

    useEffect(() => {
        const updateDimensions = () => {
            const widths = tabsRef.current.map(tab => tab?.getBoundingClientRect().width || 0);
            const offsets = tabsRef.current.map(tab => tab?.offsetLeft || 0);
            setTabWidths(widths);
            setTabOffsets(offsets);
        };

        observer.current = new ResizeObserver(updateDimensions);

        tabsRef.current.forEach(tab => {
            if (tab) observer.current.observe(tab);
        });

        updateDimensions();

        return () => {
            observer.current.disconnect();
        };
    }, [tabs.length, formattedSort]);

    return (
        <BottomTabBar>
            <TabsContainer ref={containerRef}>
                {tabs.map((tab, index) => (
                    <Tab
                        key={tab}
                        tab={tab}
                        activeTab={defaultTab}
                        onClick={() => handleTabClick(tab, index)}
                        ref={el => tabsRef.current[index] = el}
                    >
                        {tab === "Hot Posts" ? formattedSort : tab}
                        {tab === "Hot Posts" &&
                            <PostSymbol>
                                <ChevronDown size={16} />
                            </PostSymbol>
                        }
                    </Tab>
                ))}
                <Underline tabWidths={tabWidths} tabOffsets={tabOffsets} activeTabIndex={tabs.indexOf(defaultTab)} />
            </TabsContainer>
        </BottomTabBar>
    );
};

export default CommunityFeedMenu;
